import { Component, Inject, Input, OnInit, ChangeDetectorRef, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, combineLatest, NEVER, Observable } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { APP_BASE_HREF } from '@angular/common';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLConnector, GraphQLFilter, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';

export interface DialogData {
  wheres: GraphQLFilter[];
  header: string;
  selectedFunctionNumbers: any[]
}



/**
 * @title Injecting data when opening a dialog
 */
@Component({
  selector: 'function-number-pop-up.component',
  templateUrl: 'function-number-pop-up.component.html',
  styleUrls: ['./function-number-pop-up.component.css']
})
export class FunctionNumberPopUpComponent implements AfterViewInit {


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  searchControl = new UntypedFormControl('');


  functionNumbersPageObservable: Observable<any>;
  totalCount: number = 0;


  selectedFunctionNumbers: BehaviorSubject<any[]> = new  BehaviorSubject<any[]>([]);




  constructor(
    public dialogRef: MatDialogRef<FunctionNumberPopUpComponent>,
    @Inject("BASE_REPORTING") public reportingUrl: string,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public graphQlService: IGraphQlService
  ) {

    this.selectedFunctionNumbers.next(data.selectedFunctionNumbers ?? [])
  }

  ngOnInit() {
    //const query = Object.assign({}, this.query, {});
    //
    //this.userArray = this.graphQlService.getGraphQlResults(query);
    //alert(this.userArray);

  }

  ngAfterViewInit(): void {
    this.searchControl.valueChanges.subscribe(() => this.paginator.pageIndex = 0);

    this.functionNumbersPageObservable = combineLatest(
      combineLatest(this.paginator?.page.pipe(startWith(0)), this.searchControl.valueChanges.pipe(startWith(''))).pipe(
        switchMap(([page, search]) => {
          return this.graphQlService.getGraphQlResults({
            dataset: "functionNumbersPage",
            selects: [
              {
                field: "ownerTypeId",
                arguments: null
              },
              {
                field: "ownerId",
                arguments: null
              },
              {
                field: "name",
                arguments: null
              },
              {
                field: "number",
                arguments: null
              },
              {
                field: "avatarImageId",
                arguments: null
              }
            ],
            wheres: [
              { path: "name", comparison: GraphQLComparision.CONTAINS, value: search, connector: GraphQLConnector.OR } as GraphQLFilter,
              { path: "number", comparison: GraphQLComparision.CONTAINS, value: search, connector: GraphQLConnector.OR } as GraphQLFilter
            ].concat(this.data.wheres ?? []),
            groupBys: [],
            orderBy: [{ path: "name", descending: false }, { path: "number", descending: false }],
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize
          })
        }),
        map(r => {
          return r.data.functionNumbersPage;
        }),
        tap(functionNumbersPage => this.totalCount = functionNumbersPage.totalCount),
        catchError(val => {
          return NEVER;
        })
      ),
      this.selectedFunctionNumbers
    ).pipe(
      map(([functionNumbersPage, selectedFunctionNumbers]) => {
        const items = functionNumbersPage.items.map(e => Object.assign(e, { selected: selectedFunctionNumbers.find(s => s.ownerTypeId == e.ownerTypeId && s.ownerId == e.ownerId) != null }));
        return Object.assign({}, functionNumbersPage, { items: items });
      })
    );
  }



  public onSelectFunctionNumber(functionNumber) {
    

    const index = this.selectedFunctionNumbers.value.findIndex(s => s.ownerTypeId == functionNumber.ownerTypeId && s.ownerId == functionNumber.ownerId);

    if (index == -1) this.selectedFunctionNumbers.next(this.selectedFunctionNumbers.value.concat([functionNumber]));
    else {
      this.selectedFunctionNumbers.value.splice(index, 1)
      this.selectedFunctionNumbers.next(this.selectedFunctionNumbers.value);
    }
  }


  clearSelectedFunctionNumbers() {
    this.selectedFunctionNumbers.next([]);
  }

  applyChanges() {
    this.dialogRef?.close(this.selectedFunctionNumbers.value);
  }

}


